import { useEffect, useRef } from "react";

const MonthJumpSelector = ({
    isOpen,
    year,
    selectedMonthDate,
    minimumMonthDate,
    locale,
    onClose,
    onPreviousYear,
    onNextYear,
    onSelectMonth,
}) => {
    const selectorRef = useRef(null);
    const safeMinimumMonth = new Date(
        minimumMonthDate.getFullYear(),
        minimumMonthDate.getMonth(),
        1
    );

    useEffect(() => {
        if (!isOpen) {
            return undefined;
        }

        const handlePointerDown = (event) => {
            if (!selectorRef.current?.contains(event.target)) {
                onClose();
            }
        };
        const handleKeyDown = (event) => {
            if (event.key === "Escape") {
                onClose();
            }
        };

        document.addEventListener("mousedown", handlePointerDown);
        document.addEventListener("keydown", handleKeyDown);
        return () => {
            document.removeEventListener("mousedown", handlePointerDown);
            document.removeEventListener("keydown", handleKeyDown);
        };
    }, [isOpen, onClose]);

    if (!isOpen) {
        return null;
    }

    const selectedYear = selectedMonthDate.getFullYear();
    const selectedMonth = selectedMonthDate.getMonth();
    const isPreviousYearDisabled = year <= safeMinimumMonth.getFullYear();

    return (
        <div ref={selectorRef} className="month-jump-selector" role="dialog" aria-label="Select month">
            <div className="month-jump-selector__year">
                <button
                    type="button"
                    className="month-jump-selector__year-button"
                    onClick={onPreviousYear}
                    disabled={isPreviousYearDisabled}
                    aria-label="Previous year"
                >
                    &#8592;
                </button>
                <strong>{year}</strong>
                <button
                    type="button"
                    className="month-jump-selector__year-button"
                    onClick={onNextYear}
                    aria-label="Next year"
                >
                    &#8594;
                </button>
            </div>
            <div className="month-jump-selector__months">
                {Array.from({ length: 12 }, (_, monthIndex) => {
                    const targetDate = new Date(year, monthIndex, 1);
                    const isDisabled = targetDate < safeMinimumMonth;
                    const isSelected = year === selectedYear && monthIndex === selectedMonth;
                    const label = new Intl.DateTimeFormat(locale || "en", { month: "short" })
                        .format(targetDate)
                        .toUpperCase();

                    return (
                        <button
                            key={monthIndex}
                            type="button"
                            className={`month-jump-selector__month${isSelected ? " is-selected" : ""}`}
                            disabled={isDisabled}
                            onClick={() => onSelectMonth(targetDate)}
                        >
                            {label}
                        </button>
                    );
                })}
            </div>
        </div>
    );
};

export default MonthJumpSelector;
